import { Checkbox } from '@shigo-ui/ui';

import { dashboardT } from '../../../../lib/messages';
import type { TargetingDeviceType, TargetingFormValue } from '../../model';
import { toggleStringValue } from './TargetingForm.helpers';
import type { TargetingFormUpdate } from './TargetingForm.types';
import { TargetingSection } from './TargetingSection';

export function DeviceTypesTargetingSection({
  deviceTypes,
  updateField,
  value,
}: {
  deviceTypes: TargetingDeviceType[];
  updateField: TargetingFormUpdate;
  value: TargetingFormValue;
}) {
  const selectedDeviceTypeIds = new Set(value.deviceTypeIds);
  return (
    <TargetingSection title={dashboardT('targeting.deviceTypes')}>
      <div className="flex flex-wrap items-center gap-x-10 gap-y-3">
        {deviceTypes.map((deviceType) => (
          <label
            key={deviceType.deviceTypeId}
            className="text-foreground flex cursor-pointer items-center gap-2 text-sm"
          >
            <Checkbox
              checked={selectedDeviceTypeIds.has(deviceType.deviceTypeId)}
              onCheckedChange={(checked) => {
                updateField(
                  'deviceTypeIds',
                  toggleStringValue(value.deviceTypeIds, deviceType.deviceTypeId, checked === true),
                );
              }}
            />
            <span>{deviceType.name}</span>
          </label>
        ))}
        {deviceTypes.length === 0 ? (
          <p className="text-muted-foreground text-sm">{dashboardT('targeting.noDeviceTypes')}</p>
        ) : null}
      </div>
    </TargetingSection>
  );
}
